import React, { useState } from 'react';

import Button from './components/Button';
import Form from './components/Form';
import Input from './components/Input';
import List from './components/List';

function Todo() {
    const [task, setTask] = useState("");
    const [taskt, setTaskt] = useState("");
    const [taskA, setTaskA] = useState("");
    const [taskB, setTaskB] = useState("");
    const [taskC, setTaskC] = useState("");
    const [itemsList, setItemsList] = useState([]);
    const [itemstList, setItemstList] = useState([]);
    const [itemsListA, setItemstLisA] = useState([]);
    const [itemsListB, setItemstLisB] = useState([]);
    const [itemsListC, setItemstLisC] = useState([]);

    function handleChangeInput(event) {
        const inputTask = event.target.value;
        setTask(inputTask);
    }
    function handleChangeInputt(event) {
        const inputTask = event.target.value;
        setTaskt(inputTask);
    }
    function handleChangeInputA(event) {
        const inputTask = event.target.value;
        setTaskA(inputTask);
    }
    function handleChangeInputB(event) {
        const inputTask = event.target.value;
        setTaskB(inputTask);
    }
    function handleChangeInputC(event) {
        const inputTask = event.target.value;
        setTaskC(inputTask);
    }


    function handleAddItemToList(event) {
        event.preventDefault();

        if (!task) {
            return
        };

        setItemsList([...itemsList, task]);
        setItemstList([...itemstList, taskt]);
        setItemstLisA([...itemsListA, taskA]);
        setItemstLisB([...itemsListB, taskB]);
        setItemstLisC([...itemsListC, taskC]);
        setTask("");
        setTaskt("");
        setTaskA("");
        setTaskB("");
        setTaskC("");
    }

    return (
        <div className="todo-wrapper">
            <h1>ADD Card</h1>
            <Form onSubmit={handleAddItemToList}>
                <Input type="text" placeholder="y" onChange={handleChangeInput} value={task} />
                <Input type="text" placeholder="x" onChange={handleChangeInputt} value={taskt} />
                <Input type="text" placeholder="x" onChange={handleChangeInputA} value={taskA} />
                <Input type="text" placeholder="x" onChange={handleChangeInputB} value={taskB} />
                <Input type="text" placeholder="x" onChange={handleChangeInputC} value={taskC} />

                <Button type="submit">Adicionar</Button>
            </Form>
            <label>Código do Produto:</label>
            <List itemsList={itemsList} />
            <label>Descrição do Produto:</label>
            <List itemsList={itemstList} />
            <label>Unidade de medida :</label>
            <List itemsList={itemsListA} />
            <label>Data de registro da perda :</label>
            <List itemsList={itemsListB} />
            <label>Responsável pelo registro :</label>
            <List itemsList={itemsListC} />
        </div>
    );
}

export default Todo;